import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { SERVER_URL } from './config';

const HIDDEN_PATHS = ['/signup', '/login', '/verify-email', '/forgot-password', '/reset-password'];

const VerifyEmailBanner = () => {
  const { user } = useAuth();
  const location = useLocation();
  const [dismissed, setDismissed] = useState(false);
  const [resent, setResent] = useState(false);
  const [resending, setResending] = useState(false);

  if (!user || user.is_verified || dismissed) return null;
  if (HIDDEN_PATHS.includes(location.pathname)) return null;

  const handleResend = async () => {
    setResending(true);
    try {
      await fetch(`${SERVER_URL}/resend-verification`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setResent(true);
    } catch {
      // silently fail
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="bg-amber-50 border-b border-amber-100 text-amber-800 px-3 py-2 sm:px-4 sticky top-0 z-[99]">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 flex-1 min-w-0">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-4 h-4 flex-shrink-0 text-amber-500"
          >
            <path d="M1.5 8.67v8.58a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.67l-8.928 5.493a3 3 0 0 1-3.144 0L1.5 8.67Z" />
            <path d="M22.5 6.908V6.75a3 3 0 0 0-3-3h-15a3 3 0 0 0-3 3v.158l9.714 5.978a1.5 1.5 0 0 0 1.572 0L22.5 6.908Z" />
          </svg>
          <p className="text-xs sm:text-sm font-medium truncate text-amber-700">
            {resent ? 'Verification email sent! Check your inbox.' : `Please verify your email address to get the most out of Gifted.`}
          </p>
        </div>

        <div className="flex items-center gap-2 sm:gap-4 flex-shrink-0">
          {!resent && (
            <button
              onClick={handleResend}
              disabled={resending}
              className="text-[10px] sm:text-xs underline underline-offset-2 hover:text-amber-900 transition-colors font-semibold whitespace-nowrap text-amber-600 disabled:opacity-50"
            >
              {resending ? 'Sending...' : 'Resend email'}
            </button>
          )}
          <button
            onClick={() => setDismissed(true)}
            className="p-1 hover:bg-amber-100 rounded-full transition-colors flex-shrink-0 text-amber-400 hover:text-amber-600"
            aria-label="Dismiss"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-3.5 w-3.5 sm:h-4 sm:w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailBanner;
